<template>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import SettingsLayout from "@/Layouts/SettingsLayout";

export default defineComponent({
    layout: [MainLayout, SettingsLayout]
});
</script>
